<template>
  <div>
    <contenful-apis
      url="spaces/uhuxxitrg1zr/entries"
      :key="$route.params.eventSlug"
      :params="{ content_type: 'evenement', include: 3, 'fields.slug': $route.params.eventSlug }"
      :key-path="['evenement', $route.params.eventSlug]"
    />
    <vuex-api-hoc
      :key-path="['evenement', $route.params.eventSlug]"
    >
      <template slot="success"><evenement/></template>
    </vuex-api-hoc>
  </div>
</template>

<script>
import Evenement from "./evenement";

export default {
  name: "EvenementWrapper",
  components: { Evenement }
};
</script>

<style scoped>
</style>
